<template>
  <v-row class="fill-height">
    <v-col cols="12" md="6">
      <DashboardWidgetKatalogbestellungen />
    </v-col>
    <v-col cols="12" md="6">
      <DashboardWidgetBauberatungen />
    </v-col>
    <v-col cols="12" md="6">
      <DashboardWidgetNewsletterSubscriptions />
    </v-col>
    <v-col cols="12" md="6">
      <DashboardWidgetOffeneRechnungen />
    </v-col>
  </v-row>
</template>

<script>
import DashboardWidgetKatalogbestellungen from "@/components/dashboards/widgets/DashboardWidgetKatalogbestellungen.vue";
import DashboardWidgetBauberatungen from "@/components/dashboards/widgets/DashboardWidgetBauberatungen.vue";
import DashboardWidgetOffeneRechnungen from "@/components/dashboards/widgets/DashboardWidgeOffeneRechnungen.vue";
import DashboardWidgetNewsletterSubscriptions from "@/components/dashboards/widgets/DashboardWidgetNewsletterSubscriptions.vue";

export default {
  name: "DashboardGeschaeftsfuehrung",
  components: {
    DashboardWidgetNewsletterSubscriptions,
    DashboardWidgetOffeneRechnungen,
    DashboardWidgetBauberatungen,
    DashboardWidgetKatalogbestellungen,
  },
};
</script>

<style scoped></style>
